import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormControl, Validators, UntypedFormGroup } from '@angular/forms';
import { AuthenticationService, AuthResult } from 'src/app/services/authentication.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DataInput }  from '@trivelope/triv-ui-tools-lib';
import { Environment } from 'src/app/classes/environment';
import { SecondStepType, User } from 'src/app/classes/user';
import { Subscription } from 'rxjs';
import { MyReCaptchaService } from 'src/app/services/my-recaptcha.service';
import { CustomerService } from 'src/app/services/customer.service';
import { SafeUrl } from '@angular/platform-browser';



@Component({
	selector: 'app-authentication-login',
	templateUrl: './authentication-login.component.html',
	styleUrls: [ './authentication-login.component.css' ]
})
export class AuthenticationLoginComponent implements OnInit, OnDestroy {


	nStep = 1;

	loginForm = new UntypedFormGroup( {} );
	bInProgress = false;
	username = {
		label: "Benutzer", id: "username", type: "text", autocomplete: "username",
		errorMsg: "Ein gültiger Benutzername ist erforderlich"
	} as DataInput;
	password = {
		label: "Passwort", id: "password", type: "password", autocomplete: "current-password",
		errorMsg: "falsches Passwort"
	} as DataInput;
	readonly errorMsgs: { [key: string]: string } = {};
	lastResult = AuthResult.OK;

	nbAttempts = 0;
	readonly nbAttemptsBeforeCaptcha = 3;

	// recaptcha aktiviert
	recaptchaKey = this.environment.recaptchaKey;
	recaptchaCtrl = new UntypedFormControl( "", [ Validators.required ] );

	public AuthResult = AuthResult;

	public SecondStepType = SecondStepType;		// for the template
	secondStepType = SecondStepType.authenticator;
	bRequestForEmailFailed = false;

	totpCode = "";
	bShowResendBtn = false;

	subscriptions = new Subscription();
	show2FANotice = false;

	changeButtonColor = false;
	showPassword = false;

	logoSrc: SafeUrl = "";
	showRegistrationLink = false;


	constructor(
		private router: Router,
		private authenticationService: AuthenticationService,
		private matSnackBar: MatSnackBar,
		@Inject('environment') private environment: Environment,
		private myRecaptchaService: MyReCaptchaService,
		private customerService: CustomerService,
	) {
		this.showRegistrationLink = !!this.environment.features?.payments;

		this.errorMsgs[ AuthResult.KO ] = "Überprüfen Sie Ihren Benutzernamen und Ihr Passwort";
		this.errorMsgs[ AuthResult.accountLocked ] = "Dieses Konto ist gesperrt. Bitte wenden Sie sich an Ihren Administrator";
		this.errorMsgs[ AuthResult.captchaRequired ] = "Captcha benötigt";

	}


	ngOnInit() {

		this.logoSrc = this.customerService.getLoadedLogo();

		this.loginForm = new UntypedFormGroup({
			username: new UntypedFormControl('', Validators.required),
			password: new UntypedFormControl('', Validators.required)
		});

		this.loginForm.valueChanges.subscribe(() => {
			const username = this.loginForm.get('username')?.value;
			const password = this.loginForm.get('password')?.value;

			// Button aktivieren, wenn Benutzername existiert und Passwort mindestens 12 Zeichen hat
			if (username && password && password.length >= 12) {
				this.changeButtonColor = true;  //HIER
			} else {
				this.changeButtonColor = false;  //HIER
			}
		});

		console.log( "AUTHENTICATION-LOGIN.COMPONENT.TS bFirstAnimationDone?", this.authenticationService.bFirstAnimationDone )

		if( !this.authenticationService.bFirstAnimationDone ) {

			const bodys = document.getElementsByTagName( "body" );
			bodys[0].style.animation = "none";

			setTimeout( () => {
				bodys[0].style.animation = "";
			});

			setTimeout( () => {

				this.showEverything();

				this.authenticationService.bFirstAnimationDone = true;

			}, 1500 );

		}
		else {

			setTimeout( () => {
				this.showEverything();
			}, 100 );

		}

		const show2FALoginInfo = localStorage.getItem('show2FALoginInfo');

		if (show2FALoginInfo === 'true') {
			console.log('Bitte 2FA code eingeben');
			this.matSnackBar.open('Bitte melden Sie sich erneut an und geben Sie Ihren 2FA-Code ein.', '', {
			duration: 15000,
			panelClass: ['info-snackbar']
			});

			// Flag entfernen, damit die Nachricht nur einmal angezeigt wird
			localStorage.removeItem('show2FALoginInfo');
		}


		const savedUser = this.authenticationService.getCurrentUser();
		if( savedUser.ebeId ) {

			// this.loginForm.addControl( 'username', new FormControl( savedUser.ebeId, [ Validators.required ] ) );
			// this.loginForm.addControl( 'password', new FormControl( '', [ Validators.required ] ) );
			this.loginForm.updateValueAndValidity();
			this.loginForm.markAllAsTouched();
		}

		this.authenticationService.logout();

	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}


	private showEverything() {

		const cards = document.getElementsByClassName( "theCard" );
		cards[0].classList.add( "visible" );
		const mainColumns = document.getElementsByClassName( "mainColumn" );
		mainColumns[0].classList.add( "visible" );

	}


	loginStep1() {
		const username = this.loginForm.get('username')?.value;
		const password = this.loginForm.get('password')?.value;

		this.authenticationService.setTmpCredentials(username, password);

		if (this.environment.recaptchaActive) {
			this.bInProgress = true;
			this.myRecaptchaService.getToken("login").subscribe(recaptchaToken => {
				this.proceedWithLogin(username, password, recaptchaToken);
			});
		} else {
			console.log('ReCaptcha is deactivated or key is missing');
			this.proceedWithLogin(username, password, '');
		}
	}

	private proceedWithLogin( username: string, password: string, recaptchaToken: string ) {

		this.authenticationService.login( username, password, false, false, recaptchaToken ).subscribe(authResult => {

			this.bInProgress = false;
			console.log("AUTHRESULT", authResult, AuthResult);
			this.lastResult = authResult;
			this.recaptchaCtrl.setValue("");

			if( authResult === AuthResult.OK ) {

				// Erfolgreiche Authentifizierung
				const currentUser = this.authenticationService.getCurrentUser();
				console.log( 'current user', currentUser );

				this.bInProgress = true;
				this.authenticationService.initializeAppAfterAuth().subscribe( b => {

					this.bInProgress = false;
					this.matSnackBar.open('Benutzer und Kennwort sind richtig. Weiterleitung…', '', { duration: 3000 });

					const url = window.localStorage.getItem("redirectAfterLogin");
					if (url) {
						this.router.navigateByUrl(this.router.parseUrl(url));
					} else {
						this.router.navigate(['/']);
					}

				});

			}
			else if( authResult == AuthResult.twoFaActivationRequired ) {

				this.router.navigate(['/E2FA']);

			}
			else if( authResult === AuthResult.dataAgreementRequired ) {

				this.router.navigate(['/Datenschutz']);

			}
			else if( authResult === AuthResult.userAgreementRequired ) {

				this.router.navigate(['/Datenschutz']);

			}
			else if( authResult === AuthResult.secondStepNeeded ) {

				this.nStep = 2;
				console.log('secondStepneeded');
				const currentUser = this.authenticationService.getCurrentUser();
				if (currentUser.zweiFaktorEmailPruefung) {
					this.secondStepType = SecondStepType.email;
					this.bInProgress = true;
					this.authenticationService.requestTotpEmail({
						...currentUser,
						ebeId: username,
						ebePassword: password
					}).subscribe(b => {
						this.bInProgress = false;
						this.bRequestForEmailFailed = !b;
					});
				}

			} else {

				this.matSnackBar.open('Ein Fehler ist aufgetreten', '', { duration: 5000 });
				this.nbAttempts++;
				if (authResult === AuthResult.captchaRequired && this.nbAttempts < this.nbAttemptsBeforeCaptcha) {
					this.nbAttempts = this.nbAttemptsBeforeCaptcha;
				}

			}
		});
	}

	// recaptcha aktiviert
	captchaResolved( captchaResponse: string ) {
		console.log( `Resolved captcha with response: ${captchaResponse}` );
		this.recaptchaCtrl.setValue( captchaResponse );
	}

	loginStep2() {

		const u = new User();
		u.ebeId = this.loginForm.get( 'username' )?.value;
		u.ebePassword = this.loginForm.get( 'password' )?.value;
		u.zweiFaktorId = this.totpCode;

		console.log('login Step 2');

		this.bInProgress = true;
		this.authenticationService.loginWithTotp( u ).subscribe( b => {

			if( !b ) {
				this.bInProgress = false;
				this.bShowResendBtn = true;
				return;
			}

			this.authenticationService.initializeAppAfterAuth().subscribe( b2 => {
				this.bInProgress = false;

				if( b2 ) this.router.navigate( ['/'] );
			});
		});

	}

	onTotpReady( obj: { totpCode: string, bAutoSend: boolean } ) {

		this.totpCode = obj.totpCode;
		if( obj.bAutoSend ) {
			this.loginStep2();
		}
	}

  forgotPasswort() {
    this.router.navigate( [ 'login/passwort-vergessen' ] );
  }

  togglePasswordVisibility() {
	this.showPassword = !this.showPassword;
	this.password.type = this.showPassword ? "text" : "password";
	}

  	resendEmail() {

		this.bInProgress = true;
		this.authenticationService.requestTotpEmail({
			...this.authenticationService.getCurrentUser(),
			ebeId: this.loginForm.get('username')?.value,
			ebePassword: this.loginForm.get('password')?.value
		}).subscribe( b => {
			this.bInProgress = false;
			this.bRequestForEmailFailed = !b;
			this.bShowResendBtn = false;
		});

	}

}

